import { render, staticRenderFns } from "./ClassRoomCourseOutline.vue?vue&type=template&id=45abb062&scoped=true&"
import script from "./ClassRoomCourseOutline.vue?vue&type=script&lang=js&"
export * from "./ClassRoomCourseOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abb062",
  null
  
)

export default component.exports